// removed by extract-text-webpack-plugin
module.exports = {"container":"_1-_Wq3JEtFghgj4IGYBkZr","facultyRow":"_3BAif3V_2-xMaTKsOR-ABy","carousel":"_36bSyTt46_6MB5_DfpDIQg","NavPrev":"_3qON6CV8U_bDbXmYICJZb2","NavNext":"_2X3G3hkCfjWOJ7mZlRZtfz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Program/ProgramCatalogue.css
// module id = 592
// module chunks = 0